<template>
  <div>
    <div class="page-title">New Badge Form</div>
    <Form btnText="Add Badge" v-model="form" :submit="create" />
  </div>
</template>

<script>
import Form from "./_form.badges.page";
export default {
  components: { Form },
  data() {
    return {
      form: null,
    };
  },
  created() {
    this.setForm();
  },
  methods: {
    async setForm() {
      const { data } = await this.$api.Badge.new();
      this.form = data;
    },
    async create() {
      await this.$api.Badge.create(this.form);
      this.$router.push("/badges");
    },
  },
};
</script>

<style></style>
